import produce from 'immer';
import * as types from 'store/actions/types';

const INITIAL_STATE = {
	domainId: null,
	isLoading: true
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ******************** SET DOMAIN ********************
			case types.SET_DOMAIN_DATA:
				draft.domainId = action.payload;
				break;

			case types.SET_DOMAIN_LOADING:
				draft.isLoading = false;
				break;

			default:
				return state;
		}
	});
